import { createSlice } from '@reduxjs/toolkit';
import { getUsersList } from '../usersActions';

export const usersListSlice = createSlice({
  name: 'usersList',
  initialState: {
    users: [],
    error: '',
    loading: false
  },
  reducers: {},
  extraReducers: {
    [getUsersList.pending]: (state) => ({
      ...state,
      loading: true
    }),
    [getUsersList.fulfilled]: (state, { payload }) => ({
      ...state,
      users: payload.data,
      loading: false
    }),
    [getUsersList.rejected]: (state, { payload }) => ({
      ...state,
      error: payload.error,
      loading: false
    }),
  }
});

export default usersListSlice.reducer;
